import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import type { ProfileSlot } from '../profileSlots';
import { profileMessages as m } from '../profileMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ProfileSlotNoteProps {
  slots: readonly ProfileSlot[];
  /** The name in the fail sentence ("YouTube banner"). */
  name: string;
  onTryAgain: () => void;
  isBusy?: boolean;
}

/**
 * The line next to a card that works or failed (design a3.3, a3.4): "About 10 seconds…" while it
 * makes, the fail sentence with "Try again" until the user tries again (the studioActionError rule).
 */
const ProfileSlotNoteComponent: React.FC<ProfileSlotNoteProps> = ({ slots, name, onTryAgain, isBusy = false }) => {
  const intl = useIntl();
  if (slots.some((slot) => slot.state === 'making')) {
    return <span className={styles.meta}>{intl.formatMessage(m.making)}</span>;
  }
  if (!slots.some((slot) => slot.state === 'failed')) {
    return null;
  }
  // SOURCE_GONE: the photo, bank or AI picture is gone (no cover fallback); Try again opens the tool.
  const sourceGone = slots.some((slot) => slot.failed?.failCode === 'SOURCE_GONE');
  return (
    <div className={styles.error} role="alert" data-testid="profile-slot-failed">
      {intl.formatMessage(sourceGone ? m.failedSourceGone : m.failed, { name })}{' '}
      <button type="button" className={styles.link} disabled={isBusy} onClick={onTryAgain}>
        {intl.formatMessage(m.tryAgain)}
      </button>
    </div>
  );
};

export const ProfileSlotNote = TypedMemo(ProfileSlotNoteComponent);
